module.exports = __webpack_public_path__ + "img/panels-active.7ad355a5.svg";